import { type CarouselItemFieldsFragment, type InspirationItemFieldsFragment } from '../../../__generated__/graphql-client-types';
import { CARD_WIDTHS } from '../../../constants/home/general';
import { type ExclusiveDealsItem, type SaleCategoriesItem } from '../../../types/home.types';

export type HomePageCarouselItem = SaleCategoriesItem | CarouselItemFieldsFragment | ExclusiveDealsItem | InspirationItemFieldsFragment;

export const findMaxCardWidth = (itemsCount: number): number => (itemsCount > 3 ? CARD_WIDTHS[2] : CARD_WIDTHS[itemsCount - 1]);
